import { connect } from "react-redux";
import DataGrid, {
  Editing,
  Column,
  Pager,
  Paging,
  SearchPanel,
  Button,
} from "devextreme-react/data-grid";
import React from "react";
import PropTypes from "prop-types";
import CustomStore from "devextreme/data/custom_store";
import { loadMessages, formatMessage, locale } from "devextreme/localization";
import dictionary from "../../data/dictionary";
import { useHistory } from "react-router-dom";
import notify from "devextreme/ui/notify";
import { FILE_URL, WEBSITE_URL } from "../../utils/constants";
import { FAQGroupVM } from "../../model/FAQ";

loadMessages(dictionary);
const pageSizes = [10, 25, 50, 100];

const FAQGroupContainer = ({
  accessToken,
  currentLanguage,
  websiteLanguages,
  currentWebsite,
}) => {
  locale(currentLanguage.substring(0, 2));
  const history = useHistory();
  const URL = `${WEBSITE_URL}FaqGroups/${currentWebsite}`;

  const loadRequest = (url) => {
    return fetch(`${url}?page=1&pageSize=20`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Access-Control-Allow-Origin": "*",
        "Accept-Language": currentLanguage,
      },
    }).then((result) =>
      result
        .json()
        .then((json) => {
          if (result.ok) {
            return {
              data: json.data.map((data) => FAQGroupVM(data, websiteLanguages)),
              totalCount: json.totalRows,
            };
          }
          throw json.Message;
        })
        .catch(() => {
          if (result.status === 401) {
            history.push("/login");
          }
        })
    );
  };

  const onToolbarPreparing = (e) => {
    const toolbarItems = e.toolbarOptions.items;

    toolbarItems.forEach(function (item) {
      if (item.name === "addRowButton") {
        item.options = {
          icon: "plus",
          onClick: function () {
            // Implement custom save logic here
            history.push("/faq-group/add");
          },
        };
      }
    });

    toolbarItems.push({
      location: "center",
      text: "Danh sách Nhóm câu hỏi thường gặp",
    });
  };

  const deleteRequest = (url) => {
    return fetch(url, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
        "Accept-Language": currentLanguage,
      },
    }).then((result) => {
      if (result.ok) {
        return result.text().then((text) => {
          notify(
            {
              message: JSON.parse(text).message,
              position: {
                my: "center top",
                at: "center top",
              },
            },
            "success",
            3000
          );
        });
      } else {
        return result.json().then((json) => {
          throw json.Message;
        });
      }
    });
  };

  const newsData = new CustomStore({
    key: "id",
    load: (loadOptions) => loadRequest(`${URL}`, loadOptions),
    remove: (key) => deleteRequest(`${URL}/${key}`),
  });

  const gotoDetailPage = (faqGroupId) => {
    history.push(`/faq-group/${faqGroupId}`);
  };

  const imgCellRender = (data) => {
    return (
      <img
        alt="GHM Image"
        src={`${FILE_URL}/${data.value}`}
        style={{ height: 50 }}
      />
    );
  };

  return (
    <React.Fragment>
      <DataGrid
        keyExpr="id"
        dataSource={newsData}
        allowColumnReordering={true}
        remoteOperations={true}
        selection={{ mode: "single" }}
        showBorders={true}
        onToolbarPreparing={onToolbarPreparing}
      >
        <Editing useIcons={true} allowAdding={true} allowDeleting={true} />
        <SearchPanel visible={true} highlightCaseSensitive={true} />

        {websiteLanguages.map((item, index) => (
          <Column
            key={index}
            dataField={`name-${item.languageId}`}
            dataType="string"
            caption={formatMessage("name")}
            visible={item.languageId === currentLanguage}
          />
        ))}

        <Column dataField={'code'} caption={'Code'} dataType={'string'} />

        {websiteLanguages.map((item, index) => (
          <Column
            key={index}
            dataField={`description-${item.languageId}`}
            dataType="string"
            caption={formatMessage("description")}
            visible={item.languageId === currentLanguage}
          />
        ))}

        <Column dataField="thumbnail" cellRender={imgCellRender} />
        <Column
          dataField="isCustomer"
          dataType="boolean"
          caption={"Danh cho App KH"}
        />
        <Column
          dataField="alt"
          dataType="string"
          caption={formatMessage("alt")}
        />
        <Column
          dataField="seoLink"
          dataType="string"
          caption={formatMessage("seoLink")}
        />
        <Column
          dataField="order"
          dataType="number"
          caption={formatMessage("order")}
        />
        <Column
          dataField="isActive"
          dataType="boolean"
          caption={formatMessage("isActive")}
        />

        <Column type="buttons" caption={formatMessage("actionCol")}>
          <Button name="delete" />
          <Button
            hint="Info"
            icon="info"
            onClick={(e) => gotoDetailPage(e.row.key)}
          />
        </Column>

        <Pager allowedPageSizes={pageSizes} showPageSizeSelector={true} />
        <Paging defaultPageSize={10} />
      </DataGrid>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    accessToken: state.auth.data.token,
    currentLanguage: state.setting.currentLanguage,
    languages: state.setting.languages,
    currentWebsite: state.website.data.currentWebsite,
    websiteLanguages: state.website.data.languages,
  };
};

FAQGroupContainer.propTypes = {
  accessToken: PropTypes.string,
  languages: PropTypes.array,
  currentLanguage: PropTypes.string,
  websiteId: PropTypes.string,
  websiteLanguages: PropTypes.array,
  currentWebsite: PropTypes.string,
  currentWebsiteLanguage: PropTypes.string,
};

export default connect(mapStateToProps, null)(FAQGroupContainer);
